/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { oktaResourceConnectionsConfirm } from "../funcs/oktaResourceConnectionsConfirm.js";
import { oktaResourceConnectionsList } from "../funcs/oktaResourceConnectionsList.js";
import { oktaResourceConnectionsReset } from "../funcs/oktaResourceConnectionsReset.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ConfirmOktaResourceConnectionsResult } from "../models/components/confirmoktaresourceconnectionsresult.js";
import { ListOktaResourceConnectionsResult } from "../models/components/listoktaresourceconnectionsresult.js";
import { OktaResourceConnectionServer } from "../models/components/oktaresourceconnectionserver.js";
import {
  ConfirmOktaResourceConnectionsRequest,
  ConfirmOktaResourceConnectionsSecurity,
} from "../models/operations/confirmoktaresourceconnections.js";
import {
  ListOktaResourceConnectionsRequest,
  ListOktaResourceConnectionsSecurity,
} from "../models/operations/listoktaresourceconnections.js";
import {
  ResetOktaResourceConnectionRequest,
  ResetOktaResourceConnectionSecurity,
} from "../models/operations/resetoktaresourceconnection.js";
import { unwrapAsync } from "../types/fp.js";

export class OktaResourceConnections extends ClientSDK {
  /**
   * confirm oktaResourceConnections
   *
   * @remarks
   * Record that the administrator created the agent-to-resource connections for these servers in the identity provider console, with the audience each resource app is configured with. Servers that share an upstream share one Okta resource connection. Confirmation is the administrator's word; Speakeasy cannot check it. The connection must be verified or degraded. Requires org:admin and the okta-connections rollout.
   */
  async confirm(
    request: ConfirmOktaResourceConnectionsRequest,
    security?: ConfirmOktaResourceConnectionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ConfirmOktaResourceConnectionsResult> {
    return unwrapAsync(oktaResourceConnectionsConfirm(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * list oktaResourceConnections
   *
   * @remarks
   * List the Okta resource connection and derived state of every eligible MCP server. Requires org:admin and a live identity provider connection.
   */
  async list(
    request?: ListOktaResourceConnectionsRequest | undefined,
    security?: ListOktaResourceConnectionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListOktaResourceConnectionsResult> {
    return unwrapAsync(oktaResourceConnectionsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * reset oktaResourceConnections
   *
   * @remarks
   * Delete the Okta resource connection for this server's upstream so it, and every server sharing that upstream, shows as pending again. Requires org:admin.
   */
  async reset(
    request: ResetOktaResourceConnectionRequest,
    security?: ResetOktaResourceConnectionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<OktaResourceConnectionServer> {
    return unwrapAsync(oktaResourceConnectionsReset(
      this,
      request,
      security,
      options,
    ));
  }
}
